import FileLabel from "./FileLabel";
export default FileLabel;
